/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Ethnology15Inputs */

const en__field__enum_studyprograms_study_ethnology15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Ethnology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ethnology`)
};

const de__field__enum_studyprograms_study_ethnology15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Ethnology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ethnologie`)
};

/**
* | output |
* | --- |
* | "Ethnology" |
*
* @param {_Field__Enum_Studyprograms_Study_Ethnology15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_ethnology15 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Ethnology15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Ethnology15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_ethnology15(inputs)
	return de__field__enum_studyprograms_study_ethnology15(inputs)
});
export { _field__enum_studyprograms_study_ethnology15 as "_field__enum_studyPrograms_STUDY_ETHNOLOGY" }